
//导出数据更新view

// export const orderType=function(state){
// 	return state.orderType
// };
export const selectaddress=function(state){
	return state.selectaddress
};
export const coupon=function(state){
  return state.coupon
};
export const areaCoupon=function(state){
  return state.areaCoupon
};
export const payment=function(state){
  return state.payment
};
export const userInfo=function(state){
  return state.userInfo
};
export const directorText=function(state){
  return state.directorText
};
export const agentText=function(state){
  return state.agentText
};
export const receive=function(state){
  return state.receive
};




// WEBPACK FOOTER //
// ./src/store/getters.js